import * as yup from "yup";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./External.module.scss";
import { Col, Container, Row } from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import CompanyLogo from "../../resources/images/companyLogo.png";
import ExternalApplicantForm from "../../components/ExternalApplicant/ExternalForm";
import Form from "../../components/common/Form/From";
import { useDispatch, useSelector } from "react-redux";
import { ApplicantActions, companyActions, jobProfileActions } from "../../actions";
import Loader from "../../components/common/Loader/Loader";
import { FiCalendar } from "react-icons/fi";
import { MdOutlineLocationOn } from "react-icons/md";
import { BsShareFill } from "react-icons/bs";
import { toast } from "react-toastify";
import { unsecuredCopyToClipboard } from "../../helpers";
import parse from "html-react-parser";
import { CompanyService } from "../../services";
import PageNotFound from "../../components/common/noDatafound/PageNotFound";

const ExternalPage = () => {
  const { externalId } = useParams();
  const location = useLocation()
  const ExternalData = useSelector((state) => state.applicant.externalData);
  const carrierPageError = useSelector((state)=> state.applicant.error);
  const metaData = useSelector((state)=> state.company.companySettings);
  
  const [initialValues, setInitialValues] = useState({
    name: "",
    lastName: "",
    education: "",
    experienceYear: "",
    experienceMonth: "",
    currentCTC: "",
    expectedCTC: "",
    noticePeriod: "",
    country: "IN",
    phone: "",
    email: "",
    location: "",
    jobid: "",
    resume: "",
  });
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [companyData, setCompanyData] = useState(null)
  const [submited, setSubmited] = useState(null);
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const ExternalLoader = useSelector((state) => state.applicant.externalLoader);
  useEffect(() => {
    if (externalId) {
      dispatch(ApplicantActions.getExternalData(externalId));
    } 

    CompanyService.getCompanyPage().then((res) => {
      if (res) {
        setCompanyData(res);
      }
    }).catch((e) => {
      console.log("error-----", e)
    });
  }, []);


  useEffect(() => {
    if (companyData && companyData?.favicon?.url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = companyData?.favicon?.url;
    }
    if (companyData?.meta) {
      document.querySelector('meta[name="description"]').setAttribute("content", companyData?.meta);
    }
  }, [companyData]);

  useEffect(() => {
    if (location && location?.state?.externalId) {
      dispatch(ApplicantActions.getExternalData(location?.state?.externalId));
      dispatch(jobProfileActions.getCities("india"));
      localStorage.setItem("externalId", location?.state?.externalId)
    }
  }, [location])

  useEffect(() => {
    if (ExternalData && ExternalData?.location) {
      setInitialValues({ ...initialValues, location: ExternalData?.location });
    }

    if (ExternalData?.jobTitle && companyData?.pagetitle) {
      document.title = `${companyData?.pagetitle} - ${ExternalData?.jobTitle} Job`;
    }
  }, [ExternalData, companyData]);

  const SUPPORTED_FORMATS = ["application/pdf"];
  function isFileSizeValid(file) {
    if(file){
        return file?.size <= 1 * 1024 * 1000;
    }else{
        return true
    }
  }
  const ApplicantSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    education: yup.string().required("Education is required"),
    expectedCTC: yup.number().required("Expected CTC is required"),
    phone: yup.number().required("required"),
    email: yup
      .string()
      .email("Please enter valid email address")
      .required("Email is required"),
    resume: yup
      .mixed()
      .nullable()
      .test(
        "format",
        "Only the following formats are accepted: .pdf",
        (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
      ).test(
        'fileSize',
        'File size cannot exceed 1MB',
        (value) => isFileSizeValid(value)
      ).required("Resume is required"),
  });

  const handleSubmit = (values) => {
    setSubmited(true);

    if (ExternalData && values) {
      let finalPayload = values;
      let ogName = values.name;
      finalPayload.jobid = ExternalData?.id;
      if (finalPayload?.lastName && finalPayload.lastName !== "") {
        finalPayload.name = finalPayload.name + " " + finalPayload.lastName;
      }
      if (externalId) {
        finalPayload.source = "1"
      } else {
        finalPayload.source = "2"
      }
      delete finalPayload.lastName;
      dispatch(ApplicantActions.createExternalApplicant(finalPayload)).then(
        (res) => {
          setSubmited(false);
          if (res?.cid) {
            navigation("/external-success");
          } else {
            values.name = ogName;
          }
        }
      );
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setTotalPages(numPages);
  };

  function handleNext() {
    if (pageNumber < totalPages) {
      setPageNumber(pageNumber + 1);
    }
  }

  function handleCareerPage () {
    navigation("/careers");
  }
  function handlePrevious() {
    if (pageNumber > 0) {
      setPageNumber(pageNumber - 1);
    }
  }

  const renderForm = (errors, touched) => {
    return (
      <ExternalApplicantForm
        errors={errors}
        touched={touched}
        submited={submited}
        ExternalData={ExternalData}
      />
    );
  };

  const copyLink = () => {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(window.location.href);
    } else {
      unsecuredCopyToClipboard(window.location.href);
    }
    toast.success("Link has been copied to clipboard");
  };

  return (
    <>
    {
      carrierPageError === 'Invalid Link' ? <PageNotFound /> : <div className={styles.ExternalPage}>
      {ExternalLoader ? (
        <div className="middelLoader">
          <Loader color={"#5382ba"} />
        </div>
      ) : (
        <>
          <div className={styles.ExternalPageBanner}>
            {companyData && companyData?.logo?.url ?
              <div className={styles.companyIco}>
                <img
                  src={companyData?.logo?.url}
                  alt="company Logo"
                  className={styles.companyLogo}
                />
              </div>
              :
              <img
                src={CompanyLogo}
                alt="company Logo"
                className={styles.companyLogo}
              />
            }
          </div>
          <div className={styles.Externalbody}>
            <Container>
              <Row>
                <Col md={7} sm={12} className={styles.detailMainPart}>
                  {ExternalData ? (
                    <>
                      <span className={styles.companyName}> {companyData && companyData?.name} </span>
                      <div className={styles.detailPart}>
                        <h1 className={styles.detailTitle}>
                          {ExternalData?.jobTitle}
                        </h1>
                        <h6 className={styles.detailSubTitle}>
                          {ExternalData?.job_profile?.name}
                        </h6>
                        <div className={styles.sharePart}>
                          <div className={styles.box}>
                            <FiCalendar />
                            {ExternalData?.positionType}
                          </div>
                          <div className={styles.box}>
                            <MdOutlineLocationOn />
                            {ExternalData?.location}
                          </div>
                          <div
                            className={`${styles.box} ${styles.boxClick}`}
                            onClick={() => copyLink()}
                          >
                            <BsShareFill />
                            Share this job
                          </div>
                        </div>
                      </div>
                      {ExternalData?.description !== null ? (
                        <div className={styles.jdPart}>
                          {parse(ExternalData?.description)}
                        </div>
                      ) : (
                        ""
                      )}
                      {/* {ExternalData?.descriptionFile !== null ? (
                        <>
                          <div className={styles.PdfView}>
                            <div className={styles.pdfContainer}>
                              <Document
                                file={ExternalData?.descriptionFile}
                                onLoadSuccess={onDocumentLoadSuccess}
                              >
                                <Page pageNumber={pageNumber} scale={1} />
                              </Document>
                            </div>
                            <div className={styles.pdfFooter}>
                              <div className="page-text">
                                Page {pageNumber} of {totalPages}
                              </div>
                              <div className={styles.buttonContainer}>
                                <button
                                  onClick={handlePrevious}
                                  disabled={pageNumber === 1}
                                  className={`${styles.pageButton} btn btn-primary`}
                                >
                                  ‹ Previous
                                </button>
                                <button
                                  onClick={handleNext}
                                  disabled={pageNumber === totalPages}
                                  className={`${styles.pageButton} btn btn-primary`}
                                >
                                  Next ›
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )} */}
                    </>
                  ) : (
                    ""
                  )}
                </Col>
                <Col md={5} sm={12}>
                  {ExternalData?.jobStatus === 'Closed' || carrierPageError === 'Requirement for this job has been fulfilled.'?<div className="mt-5"><h5>This opening has been fulfilled please visit our careers page to  check out other available openings</h5>
                    <button
                      type="submit"
                      className={styles.brandButton}
                      onClick={handleCareerPage}
                    >
                      Careers Page
                    </button>
                  </div>:

                    <Form
                      initialValues={initialValues}
                      validationSchema={ApplicantSchema}
                      handleSubmit={handleSubmit}
                      renderForm={renderForm}
                    />
                  }
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )}
    </div>
    }
    </>
  );
};

export default ExternalPage;
